import React from "react";

const ExcelIcon = () => {
  return (
    <svg
      width="50"
      height="60"
      viewBox="0 0 50 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34 0L50 16V56C50 58.2091 48.2091 60 46 60H4C1.79086 60 1.12746e-07 58.2091 0 56V4C0 1.79086 1.79086 0 4 0H34Z"
        fill="#53D38A"
      />
      <path d="M38 16H50L34 0V12C34 14.2091 35.7909 16 38 16Z" fill="#8BE2B3" />
      <path
        d="M40 47H10V25H40V47ZM14 37V43H20V37H14ZM23 37V43H36V37H23ZM14 29V35H20V29H14ZM23 29V35H36V29H23Z"
        fill="white"
      />
    </svg>
  );
};

export default ExcelIcon;
